'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _rating = require('@alicd/next/lib/rating');

var _rating2 = _interopRequireDefault(_rating);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = require('babel-runtime/helpers/objectWithoutProperties');

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _cruiFormItem = require('@alicd/crui-form-item');

var _cruiFormItem2 = _interopRequireDefault(_cruiFormItem);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var RatingField = function (_React$Component) {
  (0, _inherits3.default)(RatingField, _React$Component);

  function RatingField() {
    (0, _classCallCheck3.default)(this, RatingField);
    return (0, _possibleConstructorReturn3.default)(this, (RatingField.__proto__ || (0, _getPrototypeOf2.default)(RatingField)).apply(this, arguments));
  }

  (0, _createClass3.default)(RatingField, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          className = _props.className,
          other1 = (0, _objectWithoutProperties3.default)(_props, ['className']);
      var bind = other1.bind,
          style = other1.style,
          inputStyle = other1.inputStyle,
          children = other1.children,
          other = (0, _objectWithoutProperties3.default)(other1, ['bind', 'style', 'inputStyle', 'children']);
      var labelCol = other.labelCol,
          wrapperCol = other.wrapperCol,
          mapping = other.mapping,
          otherInput = (0, _objectWithoutProperties3.default)(other, ['labelCol', 'wrapperCol', 'mapping']);


      if (className) {
        className += " next-form-text-align";
      } else {
        className = "next-form-text-align";
      }

      return _react2.default.createElement(
        _cruiFormItem2.default,
        (0, _extends3.default)({ className: className }, other, { style: style }),
        _react2.default.createElement(_rating2.default, (0, _extends3.default)({}, otherInput, { style: inputStyle }))
      );
    }
  }]);
  return RatingField;
}(_react2.default.Component);

exports.default = RatingField;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@alicd_crui-rating-field@0.0.8@@alicd/crui-rating-field/lib/index.js
// module id = 662
// module chunks = 0